module.exports = __webpack_public_path__ + "media/images/country_flags/hr-9fd7b1d69bdd344df93a356052b0ab7c.png";